import { deserialize } from 'cerialize'
import moment from 'moment'
import { DATE_AND_TIME_FORMAT_REVERSE } from 'Constants/Global'

export class DepartmentLogModel {
	@deserialize public id: number
	@deserialize public event_type: string
	@deserialize public message: string
	@deserialize public initiator_name: string
	@deserialize public department_inn: string
	@deserialize public department_name: string
	@deserialize public updated_at: string

	public get time_formatted(): string | undefined {
		return moment(this?.updated_at).format(DATE_AND_TIME_FORMAT_REVERSE)
	}
}
